import React from 'react';
import { Grid, Paper, useMediaQuery, useTheme } from '@mui/material';
import { useAppSelector } from '../../../store/hook';
import Transition from '../../../verticalTransition/components/Transition';
import { genericJourneyTheme } from '../../../common/styles/genericJourneyTheme';
import { PaperContainerProps } from '../PaperContainer';
import { simplifiedAuthStyles } from '../../styles/simplifiedAuth';

const PaperContainerLayout = ({ variant, children }: PaperContainerProps): React.JSX.Element => {
  const { settings } = useAppSelector((state) => state.template);
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));

  const { classes } = simplifiedAuthStyles();
  const variantConfig = variant === 'small' ? 6 : variant === 'medium' ? 9 : 12;

  const { classes: classesJourneyTheme } = genericJourneyTheme(settings);
  const documentTitle = document.title?.split('|')[0];

  return (
    <div className={classesJourneyTheme.upLayer}>
      <Transition>
        <Grid
          container
          justifyContent="center"
          className={`${classesJourneyTheme.journeyThemeGrid} ${classes.container}`}>
          <Grid item xs={lgUp ? variantConfig : smUp ? 9 : 12}>
            <Paper role="region" aria-label={documentTitle} className={classesJourneyTheme.simplifiedJourneyThemePaper}>
              <div>{children}</div>
            </Paper>
          </Grid>
        </Grid>
      </Transition>
    </div>
  );
};

export default PaperContainerLayout;
